<template>
  <!-- <v-card-text class="pt-3 pb-1" style="max-height: 650px; overflow-y: scroll" ><slot name="dialogText"></slot></v-card-text> -->

  <div style="max-height: 500px; overflow-y: scroll">
    <v-container>
      <v-row>
        <v-col v-if="show">
          <VueFileAgent
            ref="vueFileAgent"
            :thumbnailSize="120"
            :theme="'list'"
            v-model="fileRecords"
            @upload="onUpload($event)"
            :deletable="deletable"
            :uploadHeaders="uploadHeaders"
            @beforedelete="onBeforeDelete($event)"
            :accept="'.mp3'"
            @select="filesSelected($event)"
            :readonly="readonly"
            :averageColor="false"
            :helpText="$t('lang_LABEL_TRACKS_ACTION_BULK_FILE_IMPORT_UPLOADER_TEXT')"
            @upload:error="onUploadError($event)"
          ></VueFileAgent>
        </v-col>
        <v-col v-else>
          <v-simple-table dense>
            <template v-slot:default>
              <thead>
                <tr>
                  <th 
                    class="text-left report-table-header"
                    :alvqa="alvqa + '-result-table-header'"
                  >
                      {{ $t("lang_LABEL_TRACKS_ACTION_BULK_FILE_IMPORT_REPORT") }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in data" :key="item.name">
                  <td 
                    :class="[index % 3 == 0 ? 'report-table-file-name-row' : '', index != 0 && index % 3 == 0 ? 'report-table-file-name-row2' : '']"
                    :alvqa="alvqa + '-result-table-row-' + index"
                  >
                    {{ item }}
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-col>
      </v-row>
     
      <!-- <v-row>
        <v-col>
          <BaseButton v-if="show" label="lang_GENERAL_BUTTON_UPLOAD_FILES" @click="uploadFiles"/>
        </v-col>
      </v-row> -->

    </v-container>
  </div>
</template>
<script>
import store from "../store/store";
import BaseButton from './_buttons/BaseButton'


export default {
  name: "FileUploader",
  components: {
    BaseButton
  },
  data() {
    return {
      alvqa: "file-uploader"
    }
  },
  computed : {
    fileRecords: {
      get() { return this.$store.getters.getSelectedFileRecordsBulkImport },
      set( item ) { this.$store.commit('setSelectedFileRecordsBulkImport', item)},
    },
    data: {
      get() { return this.$store.getters.getSelectedFileReportDataBulkImport },
      set( item ) { this.$store.commit('setSelectedFileReportDataBulkImport', item)},
    },
    show: {
      get() { return this.$store.getters.getSelectedFileBulkImportUploader },
      set( item ) { this.$store.commit('setSelectedFileBulkImportUploader', item)},
    },
    fileRecordsForUpload: {
      get() { return this.$store.getters.getFileBulkUploaderFileRecordsForUpload },
      set( item ) { this.$store.commit('setFileBulkUploaderFileRecordsForUpload', item)},
    },
    uploadUrl: {
      get() { return this.$store.getters.getFileBulkUploaderUploadUrl },
      set( item ) { this.$store.commit('setFileBulkUploaderUploadUrl', item)},
    },
    
    uploadHeaders: {
      get() { return this.$store.getters.getFileBulkUploaderUploadHeaders },
      set( item ) { this.$store.commit('setFileBulkUploaderUploadHeaders', item)},
    },

    deletable: {
      get() { return this.$store.getters.getFileBulkUploaderDeletable },
      set( item ) { this.$store.commit('setFileBulkUploaderDeletable', item)},
    },

    readonly: {
      get() { return this.$store.getters.getFileBulkUploaderReadonly },
      set( item ) { this.$store.commit('setFileBulkUploaderReadonly', item)},
    },
  },
  methods: {
    onUploadError(failedResponses) {
      this.readonly = false;
    },
    onUpload(responses) {
      this.show = false;
      
      for (const response of responses) {
        if (response.error) {
          continue;
        }
        this.data.push(response.data[0].fileName);
        this.data.push(response.data[0].trackMessage);
        this.data.push(response.data[0].workMessage);
      }
      this.readonly = false;
      this.deletable = true

      this.$store.dispatch('fetchTracks')
    },
    filesSelected: function(fileRecordsNewlySelected) {
      var validFileRecords = fileRecordsNewlySelected.filter((fileRecord) => !fileRecord.error);
      this.fileRecordsForUpload = this.fileRecordsForUpload.concat(validFileRecords);
    },
    onBeforeDelete: function (fileRecord) { 
      var i = this.fileRecordsForUpload.indexOf(fileRecord);
      
      if(fileRecord.error !== false){
        this.$refs.vueFileAgent.deleteFileRecord(fileRecord);
      }
      if (i !== -1) {
        this.fileRecordsForUpload.splice(i, 1);
        this.$refs.vueFileAgent.deleteFileRecord(fileRecord); 
      }
    }

  }
};
</script>

<style >
.vue-file-agent .file-preview-wrapper-mp3 .file-preview {
  background:  var(--v-buttonStandard-base) !important;
}

.report-table-header {
  background-color: var(--v-headerReportFileImportBackground-base) !important; 
  color:  var(--v-headerReportFileImportFont-base) !important;
  font-weight: normal;
}

.report-table-file-name-row {
  background-color: var(--v-panelHeaderBackground-base);
}

.report-table-file-name-row2 {
  border-top: 12px solid var(--v-headerReportFileImportBackground-base);
}

</style>